var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReactTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "350px",
    height: "245px",
    viewBox: "0 0 350 245",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "reacttube-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reacttube-logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "react-tube",
    transform: "translate(28, 19.0286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "react-background-image",
    transform: "translate(0, 4.9714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#61DAFB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.671021,52.334341 C289.375174,39.9782477 286.751348,25.9125692 278.305909,17.1459368 C269.991662,8.51620485 256.46256,4.95345614 244.392962,3.33903346 C223.008783,0.480820819 181.503141,0 150.050031,0 C118.022958,0 74.3854578,0.464125651 52.2961254,3.33903346 C39.914948,4.94844759 26.1726611,8.55627325 17.4320418,17.2477774 C8.62582689,26.0094012 5.88720885,39.9682306 3.32897882,52.334341 C0.426371672,66.4284012 0,85.2805842 0,101.812139 C0,118.70097 0.655956418,139.402978 3.32897882,153.663989 C5.55923064,165.495855 8.10106176,178.730114 16.120129,187.381549 C24.9263439,196.892786 39.3573851,200.884601 52.2961254,202.660967 C74.893824,205.762929 119.728445,206 151.755517,206 C182.651065,206 223.189171,205.62102 244.392962,202.660967 C256.708544,200.939695 270.549225,197.236707 278.89627,188.236342 C286.980933,179.511448 289.27678,165.734595 291.671021,153.663989 C294.360442,140.114192 295,122.549206 295,106.929208 C295,90.0420459 294.458836,67.2982195 291.671021,52.334341 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "play",
    transform: "translate(154.7982, 103.3422) rotate(90) translate(-154.7982, -103.3422)translate(128.2995, 78.8645)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "26.4987012 0 52.9974024 48.9554195 0 48.9554195"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(45.8615, 0)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.637374,7.33352765 C125.85167,7.33352765 143.535877,53.0035795 143.535877,108.972039 C143.535877,164.940499 125.85167,210.610551 101.637374,210.610551 C77.4230781,210.610551 59.7388709,164.940499 59.7388709,108.972039 C59.7388709,53.0035795 77.4230781,7.33352765 101.637374,7.33352765 Z M101.637374,15.6498108 C84.1585582,15.6498108 68.0438205,57.2666554 68.0438205,108.972039 C68.0438205,160.677423 84.1585582,202.294268 101.637374,202.294268 C119.11619,202.294268 135.230927,160.677423 135.230927,108.972039 C135.230927,57.2666554 119.11619,15.6498108 101.637374,15.6498108 Z",
    id: "Oval",
    transform: "translate(101.6374, 108.972) rotate(30) translate(-101.6374, -108.972)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.638514,7.33082867 C125.852779,7.33082867 143.53696,53.0008801 143.53696,108.969342 C143.53696,164.937804 125.852779,210.607856 101.638514,210.607856 C77.4242482,210.607856 59.7400672,164.937804 59.7400672,108.969342 C59.7400672,53.0008801 77.4242482,7.33082867 101.638514,7.33082867 Z M101.638514,15.6471057 C84.1597266,15.6471057 68.0450107,57.2639553 68.0450107,108.969342 C68.0450107,160.674729 84.1597266,202.291579 101.638514,202.291579 C119.117301,202.291579 135.232016,160.674729 135.232016,108.969342 C135.232016,57.2639553 119.117301,15.6471057 101.638514,15.6471057 Z",
    id: "Oval",
    transform: "translate(101.6385, 108.9693) rotate(90) translate(-101.6385, -108.9693)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.639329,7.33227172 C125.853625,7.33227172 143.537832,53.0023236 143.537832,108.970783 C143.537832,164.939243 125.853625,210.609295 101.639329,210.609295 C77.4250331,210.609295 59.7408258,164.939243 59.7408258,108.970783 C59.7408258,53.0023236 77.4250331,7.33227172 101.639329,7.33227172 Z M101.639329,15.6485549 C84.1605132,15.6485549 68.0457754,57.2653995 68.0457754,108.970783 C68.0457754,160.676167 84.1605132,202.293012 101.639329,202.293012 C119.118145,202.293012 135.232882,160.676167 135.232882,108.970783 C135.232882,57.2653995 119.118145,15.6485549 101.639329,15.6485549 Z",
    id: "Oval",
    transform: "translate(101.6393, 108.9708) rotate(150) translate(-101.6393, -108.9708)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactTube);
export default __webpack_public_path__ + "static/media/reactTube.9618c2db31b7520ddf4b2886053644d2.svg";
export { ForwardRef as ReactComponent };